module.exports = __webpack_public_path__ + "media/categories/1076-3a0aaf90.svg";